var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manage-position-title title-tab"},[_vm._v(" จัดการอนุมัติพนักงาน ")])
}
var staticRenderFns = []

export { render, staticRenderFns }